// extracted by mini-css-extract-plugin
export default {"commentForm":"CommentForm_commentForm__avKDZ","avatar":"CommentForm_avatar__SvDH8","actionBtn":"CommentForm_actionBtn__0Y3kD","submitBtn":"CommentForm_submitBtn__FF83G"};